/** Helpers de stickers xat (CDN + códigos de chat). */

export function stickerImageUrl(powerSlug: string, sticker: string): string {
  const power = powerSlug.trim().toLowerCase();
  const name = sticker.trim().toLowerCase();
  return `https://util.xath.hu/i/stickers/${encodeURIComponent(power)}/${encodeURIComponent(name)}.png`;
}

export function stickerChatCode(powerSlug: string, sticker: string): string {
  return `(${powerSlug.trim().toLowerCase()}.${sticker.trim().toLowerCase()})`;
}

export function normalizeStickerCodes(list: unknown): string[] {
  if (!Array.isArray(list)) return [];
  const out: string[] = [];
  const seen = new Set<string>();
  for (const item of list) {
    const code = String(item ?? '').trim().toLowerCase();
    if (!code || seen.has(code)) continue;
    seen.add(code);
    out.push(code);
  }
  return out;
}

/** Power com galeria de stickers (categoria, type, tags ou lista preenchida). */
export function powerHasStickers(power: {
  category?: string;
  type?: string;
  categories?: string[];
  stickers?: string[];
  description?: { short?: string; long?: string };
}): boolean {
  if ((power.stickers?.length ?? 0) > 0) return true;
  const cat = power.category?.toLowerCase().trim() ?? '';
  const type = power.type?.toLowerCase().trim() ?? '';
  if (cat === 'stickers' || type === 'stickers') return true;
  if ((power.categories ?? []).includes('is_stickers')) return true;
  const blob = `${power.description?.short ?? ''} ${power.description?.long ?? ''}`.toLowerCase();
  return blob.includes('sticker');
}
